export const APPOINTMENT_TABLE = 'appointment'





// WEBPACK FOOTER //
// ./src/modules/appointment/state/search/type.js